import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/_services/authentication.service';

@Component({
  selector: 'app-companies',
  templateUrl: './companies.component.html',
  styleUrls: ['./companies.component.scss']
})
export class CompaniesComponent implements OnInit {

  constructor( private authService: AuthenticationService, private router: Router) { }
  
  companies: any;
  loading: any;

  ngOnInit(): void {
    this.getCompanies();
  }

  getCompanies(){
    this.loading = true;
    this.authService.getCompanies().then((res:any)=>{
      console.log(res);
      this.companies = res;
      this.loading = false;
    }, err=>{
      console.log(err);
      this.loading = false;
    })
  }

  companyDetails(id:any){

    this.router.navigate(['/company-details', id])
  }

}
